import React from "react";
import { Spinner } from "react-bootstrap";
import { ProgressSpinner } from "primereact/progressspinner";

const Spinners = () => {
  return (
    <div className="position-absolute top-50 start-50">
      <Spinner animation="border" />
      {/* <ProgressSpinner
        style={{ width: "50px", height: "50px" }}
        strokeWidth="4"
        fill="var(--surface-ground)"
        animationDuration=".5s"
      /> */}
    </div>
  );
};

export default Spinners;
